import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  ProductVariantRequest,
  ProductVariantResponse
} from '../models/producto-variant.model';

@Injectable({
  providedIn: 'root'
})
export class ProductoVariantApiService {
  private readonly apiUrl = `${environment.apiUrl}api/products`;

  constructor(private http: HttpClient) { }

  getProductVariants(productId: number): Observable<ProductVariantResponse[]> {
    return this.http.get<ProductVariantResponse[]>(`${this.apiUrl}/${productId}/variants`);
  }

  getProductVariantById(productId: number, variantId: number): Observable<ProductVariantResponse> {
    return this.http.get<ProductVariantResponse>(`${this.apiUrl}/${productId}/variants/${variantId}`);
  }

  createProductVariant(productId: number, req: ProductVariantRequest, businessId: number): Observable<ProductVariantResponse> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.post<ProductVariantResponse>(`${this.apiUrl}/${productId}/variants`, req, { params });
  }

  updateProductVariant(productId: number, variantId: number, req: ProductVariantRequest, businessId: number): Observable<ProductVariantResponse> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.put<ProductVariantResponse>(`${this.apiUrl}/${productId}/variants/${variantId}`, req, { params });
  }

  deleteProductVariant(productId: number, variantId: number, businessId: number): Observable<void> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.delete<void>(`${this.apiUrl}/${productId}/variants/${variantId}`, { params });
  }

  /**
   * Inc 41: sube una imagen pública para la variante. POST /api/files/upload
   * (category=PRODUCT_IMAGE, isPublic=true) → devuelve publicUrl usable como imageUrl.
   */
  uploadVariantImage(file: File): Observable<VariantImageUploadResponse> {
    const form = new FormData();
    form.append('file', file, file.name);
    const params = new HttpParams()
      .set('category', 'PRODUCT_IMAGE')
      .set('isPublic', 'true');
    return this.http.post<VariantImageUploadResponse>(
      `${environment.apiUrl}api/files/upload`, form, { params });
  }
}

export interface VariantImageUploadResponse {
  fileId: number;
  fileName: string;
  originalName: string;
  contentType: string;
  fileSize: number;
  publicUrl?: string;
  isPublic?: boolean;
}
